// @src/pre-deployment/src/components/About.js v1.0
// - About page component explaining the Korean learning application
// - Placeholder for future detailed about page

import React from 'react';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/app-homepage');
  };

  return (
    <div className="about-container">
      {/* Menu Top Navigation */}
      <div className="menu-top-navigation">
        <div className="module-info">
          <span>About</span>
          <span className="separator">•</span>
          <span>Korean Learning App</span>
        </div>
        
        <div className="module-nav-buttons">
          <button className="module-nav-btn secondary" onClick={handleBackToHome}>
            <i className="fas fa-home"></i>
            Back to Home
          </button>
        </div>
      </div>

      <div className="about-content">
        <div className="about-header">
          <h1>About Korean Learning Application</h1>
          <p className="about-subtitle">Learn Korean online with interactive exercises and structured lessons</p>
        </div>

        <div className="about-sections">
          <section className="about-section">
            <h2>🎯 Our Mission</h2>
            <p>
              This application is designed to help you learn Korean through interactive exercises, 
              structured lessons, and comprehensive practice modules. Whether you're a complete 
              beginner or looking to improve your existing skills, our platform provides a 
              systematic approach to Korean language learning.
            </p>
          </section>

          <section className="about-section">
            <h2>📚 Learning Features</h2>
            <ul>
              <li><strong>Dialogue Practice:</strong> Interactive conversations with native speakers</li>
              <li><strong>Vocabulary Building:</strong> Essential Korean words and phrases</li>
              <li><strong>Translation Matching:</strong> Connect Korean and English meanings</li>
              <li><strong>Grammar Exercises:</strong> Master Korean grammar patterns</li>
              <li><strong>Cloze Exercises:</strong> Fill-in-the-blank practice</li>
              <li><strong>Shape Puzzles:</strong> Sentence building and construction</li>
            </ul>
          </section>

          <section className="about-section">
            <h2>🎓 Level System</h2>
            <p>
              Our curriculum is organized into 6 levels (1급 - 6급) following the Korean 
              language proficiency standards. Each level contains 10 chapters with 
              progressively challenging content designed to build your Korean language skills.
            </p>
          </section>

          <section className="about-section">
            <h2>🚀 Getting Started</h2>
            <p>
              Begin by selecting your appropriate level from the homepage. If you're unsure 
              of your level, start with Level 1 (1급) and work your way up. Each chapter 
              contains multiple exercise types to reinforce your learning.
            </p>
          </section>
        </div>

        <div className="about-footer">
          <button className="start-button" onClick={handleBackToHome}>
            <i className="fas fa-arrow-left"></i>
            Back to Learning
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
